import React from 'react';
import FormModal from '../../../components/Modals/FormModal';
import { useCorrelativesAdmin } from '../../../hooks/settings/useCorrelativesAdmin';
import ButtonCustom from '../../../pages/UiElements/ButtonCustom';

/**
 * 🔁 CorrelativeResetModal
 *
 * Modal de confirmación y detalle para el restablecimiento
 * manual de un correlativo.
 */
const CorrelativeResetModal: React.FC = () => {
  const {
    selected,
    showModal,
    handlerCloseModal,
    handlerResetSequence,
    isSubmitting,
  } = useCorrelativesAdmin();

  if (!selected) return null;

  return (
    <FormModal
      isOpen={showModal}
      onClose={handlerCloseModal}
      title="Detalle de Correlativo"
      maxWidth="max-w-md"
    >
      <div className="space-y-4 text-sm">
        <div>
          <strong>Sucursal:</strong> {selected.branchName}
        </div>

        <div>
          <strong>Tipo de Documento:</strong> {selected.documentTypeName}
        </div>

        <div>
          <strong>Prefijo:</strong> {selected.prefix}
        </div>

        <div>
          <strong>Correlativo Actual:</strong>{' '}
          {selected.currentNumber ?? '—'}
        </div>

        <div>
          <strong>Último Reset:</strong> {selected.lastResetYear}
        </div>

        {/* ⚠️ Acción */}
        <div className="pt-6 flex justify-end gap-3">
          <ButtonCustom
            text="Cancelar"
            variant="secondary"
            onClick={handlerCloseModal}
            disabled={isSubmitting}
          />

          <ButtonCustom
            text="Restablecer correlativo"
            variant="danger"
            iconKey="return"
            onClick={() => handlerResetSequence(selected.id)}
            disabled={isSubmitting}
          />
        </div>
      </div>
    </FormModal>
  );
};

export default CorrelativeResetModal;
